import { baseURL } from '@/httpService/API';
import { hMacAjax as fetch } from 'grt-tool-lib-front';
let reqUrl = baseURL + '/grt-user-center-service',
 systemUrl = baseURL + '/apaas-system-service',
 url = {
    realDetail: '/user/student/v1/getVerifyState',
    needVerify: '/user/verify/v1/getVerifyFlag',
    photoCheck: '/user/verify/v1/photoFaceCheck',
    configFlag: '/user/systemConfig/v1/getByType', //学员端查询实名配置开关
    installList: `${systemUrl}/application/v1/installed`,
    promptbox: '/user/integration-project/v1/promptbox'
};
//获取已安装的应用列表
export function getInstallAppList(data) {
    return fetch.post(url.installList, data);
}
//照片比对
export const handlePhotoCheck = (data) => {
    return fetch.post(`${reqUrl}${url.photoCheck}`, data);
};
//查询实名详情---实名的状态及详细信息
export const handleRealDetail = (data) => {
    return fetch.get(`${reqUrl}${url.realDetail}`, data);
};

//判断业务是否需要实名或者人脸，后端已经包含了getRealFlag的逻辑----（后端根据业务id返回对应结果，项目、开放课、报名是实名，考试是人脸）
export const isBusinessNeedVerify = (data) => {
    return fetch.get(`${reqUrl}${url.needVerify}`, data);
};

//查询实名配置开关--个人中心处使用
export const getRealFlag = () => {
    let data = {
        type: 'real_name_authentication'
    };
    return fetch.get(`${reqUrl}${url.configFlag}`, data);
};

//项目弹框整合
export const handleRealPrompt = (data) => {
    return fetch.get(`${reqUrl}${url.promptbox}`, data);
};